import React from "react";
import "./PipelineDetails.scss";
import { stringISOtoUS } from "../../date-converter";
import { calculateTotalColumn, getPaymentPercentage, getPaymentThreshold, percent, getAgentPercentage, convertDateTimeFormatToDate } from "../../utils";
import dollars from "../../dollar-format";
import { Link, browserHistory } from "react-router";
import { GrossType } from "../../consts/consts";
import BucketIcon from "./BucketIcon/BucketIcon";
import moment from "moment/moment";
import { ApolloConsumer } from "@apollo/client";
import hscTeamMembers from "../../hsc-team-members";
import Input from "../Input/Input";
import SelectTeam from "../SelectTeam/SelectTeamAgentCommissionDetails";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import agentCommissionTransactionTypes from "../../agent-commission-transaction-types";
import ReusableSpinner from "../ReactTable/ReusableSpinner";

import svgSortAsc from "../../svgs/arrow-up.svg";
import svgSortDesc from "../../svgs/arrow-down.svg";
import Icon from "../Icon";

export const courting = 'Courting';
export const followup = 'Follow Up';
export const property = 'Properties';
export const agent = 'Agents';
export const investor = 'Investors';
export const lender = 'Lenders';
export const hotlist = 'Hot List';
export const proposal = "Proposal";
export const active = "Active";
export const negotiation = "In Negotiation";
export const underContract = "Under Contract";
export const closed = "Closed";
export const closedYTD = "Closed YTD";
export const closedHistorical = "Closed Historical";
export const listing = "Listing";

export default class PipelineDetails extends React.Component {
  constructor(props) {
    super(props);
    this.client = null;
    this.checkIfHscAgent  = this.checkIfHscAgent.bind(this);
    this.getValuesForDropdown = this.getValuesForDropdown.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTrasactionTypeChange = this.handleTrasactionTypeChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.checkIfHscAgent  = this.checkIfHscAgent.bind(this);
    this.state = {
        sortState: {}
    };

    this.sortBy = this.sortBy.bind(this);
  }

  static getColumns(status, isAgentPipeline, grossType) {
    const cols = [];
    const isAgentCommission = grossType === GrossType.Procured || grossType === GrossType.Paid;
    switch (status) {
      case followup:
          cols.push({
              label: 'Date Modified',
              key: 'LAST_MODIFIED_DATE',
              style: 'center',
          },{
              label: 'Status',
              key: 'STATUS',
              style: 'center',
          });
          break;
      case courting:
          cols.push({
              label: 'Date Modified',
              key: 'LAST_MODIFIED_DATE',
              style: 'center',
          },{
              label: 'Status',
              key: 'STATUS',
              style: 'center',
          });
          break;
      case property:        
        cols.push({
            label: 'Date Modified',
            key: 'LAST_MODIFIED_DATE',
            style: 'center',
        },{
          label: 'Status',
          key: 'STATUS',
          style: 'center',
        });
        break;
      case hotlist:
        cols.push({
            label: 'Status',
            key: 'STATUS',
            style: 'center',
        },{
            label: 'Date Created',
            key: 'DATE_CREATED',
            style: 'center',
        });
        break;
      case proposal:
        cols.push({
          label: "Date",
          key: "PROPOSAL_DATE",
          style: "center",
        });
        break;
      case active: {
        cols.push({
          label: "Date Listed",
          key: "LISTED_DATE",
          style: "center",
        });
        if (isAgentPipeline)
          cols.push({
            label: "Expiration Date",
            key: "EXPIRATION_DATE",
            style: "center",
          });
        break;
      }
      case negotiation:
      case underContract:
        cols.push({
          label: "Status",
          key: "STATUS",
          style: "center",
        });
        break;
      case closed:
      case closedYTD:
      case closedHistorical:
        cols.push({
          label: "Close of Escrow",
          key: "CLOSE_OF_ESCROW",
          style: "center",
        });
        break;
      case listing:
        cols.push(
          {
            label: "Status",
            key: "STATUS",
            style: "center",
          },
          {
            label: "Date",
            key: "LISTED_DATE",
            style: "center",
          }
        );
        break;
    }
    if ([agent, investor, lender].includes(status)) {
      cols.push({
        label: 'First Name',
        key: 'FIRST_NAME',
        style: 'center',
      }, {
        label: 'Last Name',
        key: 'LAST_NAME',
        style: 'center',
      }, {
        label: 'Email',
        key: 'EMAIL',
        style: 'center',
      }, {
        label: 'Cell Phone',
        key: 'CELL_PHONE',
        style: 'center',
      });
    }
    if ([agent].includes(status)) {
      cols.push({
        label: 'Firm',
        key: 'FIRM',
        style: 'center',
      });
    }
    if ([investor].includes(status)) {
      cols.push({
        label: 'Company',
        key: 'COMPANY_NAME',
        style: 'center',
      });
    }
    if ([lender].includes(status)) {
      cols.push({
        label: 'Company',
        key: 'COMPANY_NAME',
        style: 'center',
      });
    }

    if (![agent].includes(status) && ![investor].includes(status)) {
      cols.push({
        label: 'Property Name',
        key: 'NAME',
      });
    }

    if ([active, listing, proposal, hotlist, property, followup, courting].includes(status))
      cols.push({
        label: 'Address',
        key: 'ADDRESS',
      });
    if (![agent].includes(status) && ![investor].includes(status)) {
      cols.push({
        label: 'City',
        key: 'CITY',
      }, {
        label: 'State',
        key: 'STATE',
        style: 'center',
      });
    }
    // cols.push({
    //   label: "Property Name",
    //   key: "NAME",
    // });
    // if ([active, listing, proposal].includes(status))
    //   cols.push({
    //     label: "Address",
    //     key: "ADDRESS",
    //   });
    // cols.push(
    //   {
    //     label: "City",
    //     key: "CITY",
    //   },
    //   {
    //     label: "State",
    //     key: "STATE",
    //     style: "center",
    //   }
    // );
    let priceLabel = "";
    switch (status) {
      case hotlist:
        priceLabel = 'Price';
        break;
      case proposal:
      case active:
        priceLabel = "List Price";
        break;
      case listing:
      case negotiation:
      case underContract:
        priceLabel = "Price";
        break;
      case closed:
      case closedYTD:
      case closedHistorical:
        priceLabel = "STRIVE Fee";
        break;
      case property:
        priceLabel = 'Price';
        break;
      case followup:
          priceLabel = 'Price';
          break;
      case courting:
          priceLabel = 'Price';
          break;
    }
    if (![property, agent, investor,followup,courting].includes(status)) {
      cols.push({
        label: priceLabel,
        key: 'PRICE',
        style: 'center',
        isPrice: true,
        withCents: true,
      });
    }
    if ([property,courting,followup].includes(status)) {
      cols.push({
        label: priceLabel,
        key: 'LIST_PRICE',
        style: 'center',
        isPrice: true,
        withCents: true,
      });
    }
    if ([ negotiation, underContract, closed, closedYTD,  closedHistorical].includes(status)) {
      cols.push({
        label: "% STRIVE Fee",
        key: "PERCENTAGE",
        style: "center",
      });
      if (isAgentCommission) {
        cols.push({
          label: `Gross Commission${grossType === GrossType.Paid ? " (Paid)" : "" }`,
          key: "GROSS_FEE",
          style: "center",
          isPrice: true,
          withCents: true,
        });
        // if (grossType === GrossType.Paid) {
          cols.push(
            {
              label: "Net Commission",
              key: "NET_FEE",
              style: "center",
              isPrice: true,
              withCents: true,
            },
            {
              label: "Net %",
              key: "NET_PERCENT",
              style: "center",
            }
          );
        // }
      } else
        cols.push(
          {
            label: "Fee Percentage",
            key: "SELLER_FEE_PERCENTAGE",
            style: "center",
          },
          {
            label: "Gross Fee",
            key: "GROSS_FEE",
            style: "center",
            isPrice: true,
            withCents: true,
          });
      cols.push(
        {
          label: "Additional Agent",
          key: "ADDITIONAL_AGENTS",
        },
        {
          label: "Procured",
          key: "PROCURED",
          style: "center",
        },
        {
          label: "%  of Deal",
          key: "TOTAL_PERCENTAGE",
          style: "center",
        },
        {
          label: `Gross Cumulative${grossType === GrossType.Paid ? " (Procured)" : "" }`,
          key: "GROSS_CUMULATIVE",
          style: "center",
          isPrice: true,
          withCents: true,
        });
    }
    if ([hotlist].includes(status))
      cols.push({
          label: 'Seller',
          key: 'SELLER',
          style: 'center',
      });
      if (![proposal].includes(status) && ![hotlist].includes(status) && 
      ![property].includes(status) && ![agent].includes(status) && ![investor].includes(status) 
      && ![courting].includes(status) && ![followup].includes(status) && !isAgentCommission)
          cols.push({
              label: 'Downloads',
              key: 'DOWNLOADS',
              style: 'center',
          });
      return cols;
  }

  static formatAdditionalAgents(property) {
    let additionalAgents = "";
    for (let i = 1; i <= 6; i++) {
      if (
        (property[`ADDITIONAL_AGENT_${i}_FIRST_NAME`] || property[`ADDITIONAL_AGENT_${i}_LAST_NAME`]) &&
        (!additionalAgents.includes(  property[`ADDITIONAL_AGENT_${i}_FIRST_NAME`] ) || !additionalAgents.includes( property[`ADDITIONAL_AGENT_${i}_LAST_NAME`]))) {
        additionalAgents += additionalAgents ? "," : "";
        if (property[`ADDITIONAL_AGENT_${i}_FIRST_NAME`]) {
          additionalAgents += " " + property[`ADDITIONAL_AGENT_${i}_FIRST_NAME`];
        }
        if (property[`ADDITIONAL_AGENT_${i}_LAST_NAME`]) {
          additionalAgents += " " + property[`ADDITIONAL_AGENT_${i}_LAST_NAME`];
        }
      }
    }
    return additionalAgents;
  }

  static getAgentContribution(property, agentId) {
    const agents = {};

    // Listing agents
    if (property.LISTING_AGENT_1) {
        agents[property.LISTING_AGENT_1] = parseFloat(property.LISTING_AGENT_1_PERCENT) || 0;
    }
    if (property.LISTING_AGENT_2) {
        agents[property.LISTING_AGENT_2] = (agents[property.LISTING_AGENT_2] || 0) + parseFloat(property.LISTING_AGENT_2_PERCENT) || 0;
    }
    if (property.LISTING_AGENT_3) {
        agents[property.LISTING_AGENT_3] = (agents[property.LISTING_AGENT_3] || 0) + parseFloat(property.LISTING_AGENT_3_PERCENT) || 0;
    }

    // Buyer agents
    if (property.BUYER_AGENT_1) {
        agents[property.BUYER_AGENT_1] = (agents[property.BUYER_AGENT_1] || 0) + parseFloat(property.BUYER_AGENT_1_PERCENT) || 0;
    }
    if (property.BUYER_AGENT_2) {
        agents[property.BUYER_AGENT_2] = (agents[property.BUYER_AGENT_2] || 0) + parseFloat(property.BUYER_AGENT_2_PERCENT) || 0;
    }
    if (property.BUYER_AGENT_3) {
        agents[property.BUYER_AGENT_3] = (agents[property.BUYER_AGENT_3] || 0) + parseFloat(property.BUYER_AGENT_3_PERCENT) || 0;
    }
    if (property.LENDER_1) {
        agents[property.LENDER_1] = parseFloat(property.LENDER_1_PERCENT) || 0;
    }
    if (property.LENDER_2) {
        agents[property.LENDER_2] = (agents[property.LENDER_2] || 0) + parseFloat(property.LENDER_2_PERCENT) || 0;
    }
    if (property.LENDER_3) {
        agents[property.LENDER_3] = (agents[property.LENDER_3] || 0) + parseFloat(property.LENDER_3_PERCENT) || 0;
    }

       
    const totalContributions = Object.values(agents).reduce((sum, value) => sum + value, 0);    
    const agentContribution = agents[agentId] || 0;
    return (agentContribution / totalContributions) * 100;
}
  static buildRow(status, property, grossType, previousCumulative, id) {  
    let price = 0,grossFee = 0,grossCumulative = 0, netFee = 0,netPercent = 0,grossCumulativeForPaid = 0, strivePercentage = 0;
    let additionalAgents = "";
    const percentage = property.PERCENTAGE
      ? parseFloat(property.PERCENTAGE || 0)
      : parseFloat(property.LISTING_PERCENTAGE || 0) +
        parseFloat(property.BUYING_PERCENTAGE || 0);
    if(status === hotlist){
        property.SELLER = (property.seller_first_name !== null ? property.seller_first_name : "") + " " + (property.seller_last_name !== null ? property.seller_last_name : "");
    }
    // const downloads = property.USERS_ID      // we are not using this because of missmatch so dowload_count we have now.
    //   ? property.USERS_ID.split(",").length
    //   : 0;  
     const downloads = property.DOWNLOADS_COUNT     
      ? property.DOWNLOADS_COUNT
      : 0; 
    if (
      status == underContract || status == negotiation || status == closedYTD || status == closedHistorical || status == closed){
      const agentNumbers = [1, 2, 3];
      let totalAgentPercentage = 0;

      agentNumbers.forEach((agentNumber) => {
        const buyerAgentKey = `BUYER_AGENT_${agentNumber}`;
        const listingAgentKey = `LISTING_AGENT_${agentNumber}`;

        if (property[buyerAgentKey] === id) {
          totalAgentPercentage += parseFloat(property[`${buyerAgentKey}_PERCENT`]);
        }

        if (property[listingAgentKey] === id) {
          totalAgentPercentage += parseFloat(property[`${listingAgentKey}_PERCENT`]);
        }
      });
      property.PROCURED = [
          property.BUYER_AGENT_1,
          property.BUYER_AGENT_2,
          property.BUYER_AGENT_3,
          property.LISTING_AGENT_1,
          property.LISTING_AGENT_2,
          property.LISTING_AGENT_3
      ].some(agent => agent === id);          
      property.TOTAL_PERCENTAGE= totalAgentPercentage,
      property.POTENTIAL_FEE= property.POTENTIAL_FEE,
      property.TRANSACTION_TYPE= property.TRANSACTION_TYPE
      property.REFERRAL_FEE= property.REFERRAL_FEE
    }
    switch (status) {
      case hotlist:
      case proposal:
      case active:
        price = property.list_price ? property.list_price : property.LIST_PRICE;
        break;
      case negotiation:
      case underContract:
        price = property.NEGOTIATION_PRICE;
        grossFee = parseFloat(property.NEGOTIATION_LISTING_GROSS_FEE || 0) + parseFloat(property.NEGOTIATION_BUYING_GROSS_FEE || 0);
        additionalAgents = PipelineDetails.formatAdditionalAgents(property);
        grossCumulative = previousCumulative + grossFee;
        break;
      case closed:
      case closedYTD:
      case closedHistorical:
        price = property.TRANSACTION_TYPE === "Referral" ? (property.REFERRAL_FEE !== null ? property.REFERRAL_FEE : 0) : property.POTENTIAL_FEE;
        additionalAgents = property.ADDITIONAL_AGENTS ? property.ADDITIONAL_AGENTS : PipelineDetails.formatAdditionalAgents(property);
        switch (grossType) {
          case GrossType.Procured: {
            strivePercentage = PipelineDetails.getAgentContribution(property, id);
            grossFee = parseFloat(property.LISTING_GROSS_COMMISSION || 0) + parseFloat(property.BUYING_GROSS_COMMISSION || 0);
            grossCumulative = previousCumulative + grossFee;

            const listingGrossCommission = parseFloat(property.listingGrossCommission) ? parseFloat(property.listingGrossCommission || 0) : parseFloat(property.LISTING_GROSS_COMMISSION || 0);
            const buyingGrossCommission = parseFloat(property.buyingGrossCommission) ? parseFloat(property.buyingGrossCommission || 0) : parseFloat(property.BUYING_GROSS_COMMISSION || 0);
            grossCumulativeForPaid = property.TRANSACTION_TYPE == "Extra Payment" ? previousCumulative : previousCumulative + listingGrossCommission + buyingGrossCommission;

            const agentPreviousPercent = getPaymentPercentage(previousCumulative, property.CLOSE_OF_ESCROW) / 100;
            const agentPercent = getPaymentPercentage(grossCumulative, property.CLOSE_OF_ESCROW) / 100;
            if (agentPreviousPercent !== agentPercent) {
              const threshold = getPaymentThreshold(grossCumulative, property.CLOSE_OF_ESCROW);
              if (grossFee >= (threshold - previousCumulative)) {
                netFee = (threshold - previousCumulative) * agentPreviousPercent + (grossFee - (threshold - previousCumulative)) * agentPercent;
              } else {
                netFee = (grossFee - (grossCumulative - threshold)) * agentPreviousPercent + (grossCumulative - threshold) * agentPercent;
              }

            } else
              netFee = grossFee * agentPercent;
            const percentage = netFee && grossFee ? netFee / grossFee * 100 : 0;
            netPercent = percent(percentage, 2);
            break;
          }
          case GrossType.Paid: {
            strivePercentage = property.PERCENTAGE ? parseFloat(property.PERCENTAGE): 0 ;
            grossFee = parseFloat(property.TEAM_MEMBER_GROSS_FEE || 0);
            const striveFee = property.TRANSACTION_TYPE == "Investment Sales" ? parseFloat(property.POTENTIAL_FEE || 0) : parseFloat(property.REFERRAL_FEE || 0);
            const agentPercentage = getAgentPercentage(property, id);
            const procuredGrossFee = striveFee * agentPercentage;
            grossCumulative =  property.TRANSACTION_TYPE == "Extra Payment" ? previousCumulative : previousCumulative + procuredGrossFee; 
            // grossCumulative = previousCumulative + procuredGrossFee;

            const listingGrossCommission = parseFloat(property.listingGrossCommission) ? parseFloat(property.listingGrossCommission || 0) : parseFloat(property.LISTING_GROSS_COMMISSION || 0);
            const buyingGrossCommission = parseFloat(property.buyingGrossCommission) ? parseFloat(property.buyingGrossCommission || 0) : parseFloat(property.BUYING_GROSS_COMMISSION || 0);
            grossCumulativeForPaid = property.TRANSACTION_TYPE == "Extra Payment" ? previousCumulative : previousCumulative + listingGrossCommission + buyingGrossCommission;

            const agentPreviousPercent = getPaymentPercentage(previousCumulative, property.CLOSE_OF_ESCROW) / 100;
            const agentPercent = getPaymentPercentage(grossCumulative, property.CLOSE_OF_ESCROW) / 100;
            if (agentPreviousPercent !== agentPercent) {
              const threshold = getPaymentThreshold(grossCumulative, property.CLOSE_OF_ESCROW);
              const amountOverThreshold = grossCumulative - threshold;
              if (grossFee >= (threshold - previousCumulative)) {
                netFee = (threshold - previousCumulative) * agentPreviousPercent + (grossFee - (threshold - previousCumulative)) * agentPercent;
              } else {
                netFee = (grossFee - (grossCumulative - threshold)) * agentPreviousPercent + (grossCumulative - threshold) * agentPercent;
              }
            } else
              netFee = grossFee * agentPercent;
            const percentage = netFee && grossFee ? netFee / grossFee * 100 : 0;
            netPercent = percent(percentage, 2);
            break;


            
          }
          default: {
            grossFee = parseFloat(property.CLOSED_LISTING_GROSS_FEE || 0) + parseFloat(property.CLOSED_BUYING_GROSS_FEE || 0) + parseFloat(property.CLOSED_REFERRAL_FEE || 0);
            grossCumulative = previousCumulative + grossFee;
          }
        }
        break;
      case listing:
        switch (property.STATUS) {
          case active:
            price = property.LIST_PRICE;
            break;
          case negotiation:
          case underContract:
            price = property.NEGOTIATION_PRICE;
            grossFee = parseFloat(property.NEGOTIATION_LISTING_GROSS_FEE || 0) + parseFloat(property.NEGOTIATION_BUYING_GROSS_FEE || 0);
            additionalAgents = PipelineDetails.formatAdditionalAgents(property);
            break;
        }
        break;
        case property:
              price = property.LIST_PRICE;
              break;
    }

    return {
      ID: property.ARCIMEDES_ROW_ID?property.ARCIMEDES_ROW_ID:property.arcimedes_row_id?property.arcimedes_row_id:null,
      DATE_CREATED: property.DATE_CREATED
        ? stringISOtoUS(property.DATE_CREATED)
        : property.date_created?stringISOtoUS(property.date_created):null,
      PROPOSAL_DATE: property.PROPOSAL_DATE
        ? stringISOtoUS(property.PROPOSAL_DATE)
        : null,
      LISTED_DATE: property.LISTED_DATE
        ? stringISOtoUS(property.LISTED_DATE)
        : property.listed_date?stringISOtoUS(property.listed_date):null,
      EXPIRATION_DATE: property.EXPIRATION_DATE
        ? stringISOtoUS(property.EXPIRATION_DATE)
        : null,
      STATUS: property.STATUS 
        ? property.STATUS : property.status ? property.status 
            : (property.HSC_STATUS && property.SOURCE === 'HSC') 
                ? property.HSC_STATUS:property.hsc_status?property.hsc_status: null,
      CLOSE_OF_ESCROW: property.CLOSE_OF_ESCROW
        ? convertDateTimeFormatToDate(property.CLOSE_OF_ESCROW)
        : null,
      NAME: property.NAME?property.NAME:property.name?property.name:null,
      ADDRESS: property.ADDRESS?property.ADDRESS:property.address?property.address:null,
      CITY: property.CITY?property.CITY:property.city?property.city:null,
      STATE: property.STATE?property.STATE:property.state?property.state:null,
      PRICE: price ? parseFloat(price) : 0,
      PERCENTAGE: strivePercentage ? `${strivePercentage.toFixed(2)}%` : '0.00%',//percentage ? `${percentage.toFixed(2)}%` : "0.00%",
      SELLER_FEE_PERCENTAGE: property.SELLER_FEE_PERCENTAGE ? `${parseFloat(property.SELLER_FEE_PERCENTAGE).toFixed(2)}%` : "0.00%",
      GROSS_FEE: grossFee ? grossFee : 0,
      GROSS_CUMULATIVE: grossType === GrossType.Paid ? (grossCumulativeForPaid ? grossCumulativeForPaid : 0) : (grossCumulative ? grossCumulative : 0),
      NET_FEE: netFee ? netFee : 0,
      NET_PERCENT: netPercent ? netPercent : 0,
      ADDITIONAL_AGENTS: additionalAgents,
      DOWNLOADS: downloads,
      SOURCE: property.SOURCE,
      TRANSACTION_TYPE: property.TRANSACTION_TYPE,
      LIST_PRICE: property.list_price,
      PROCURED: property.TRANSACTION_TYPE=== 'Extra Payment' ? false : property.PROCURED,
      TOTAL_PERCENTAGE: property.TRANSACTION_TYPE=== 'Extra Payment' ? '0.00%' : isNaN(property.TOTAL_PERCENTAGE) ? '0.00%' : `${Number(property.TOTAL_PERCENTAGE).toFixed(2)}%`,
      SELLER:property.SELLER,
      FIRST_NAME: property.first_name ? property.first_name : '',
      LAST_NAME: property.last_name ? property.last_name : '',
      EMAIL: property.email ? property.email : '',
      CELL_PHONE: property.cell_phone ? property.cell_phone : '',
      PHONE: property.phone ? property.phone : '',
      FIRM: property.firm ? property.firm : '',
      COMPANY_NAME: property.company_name ? property.company_name : '',
      CONTACT_ID: property.contact_id ? property.contact_id : '',
      AGENT_TYPE: property.__typename==='HSCAgent' ? 'agent' :  property.__typename==='Investors'?'investor':null,
      LAST_MODIFIED_DATE: property.LAST_MODIFIED_DATE ? property.LAST_MODIFIED_DATE : property.last_modified_date? property.last_modified_date : '',
    };
  }

  static buildTableRows(status, data, grossType, id) {
    const tableData = [];
    data.map((property, index) => {
      const previousCumulative = index > 0 ? tableData[index - 1].GROSS_CUMULATIVE : 0;
      tableData[index] = PipelineDetails.buildRow(status, property, grossType, previousCumulative, id);
    });
    return tableData;
  }

  static buildTableTotal(data) {
    const price = calculateTotalColumn(data, "PRICE");
    const grossFee = calculateTotalColumn(data, "GROSS_FEE");
    const grossCumulative = data[data.length - 1].GROSS_CUMULATIVE;
    const netFee = calculateTotalColumn(data, "NET_FEE");
    const downloads = calculateTotalColumn(data, "DOWNLOADS");
    return {
      ID: "Total",
      DATE_CREATED: null,
      LISTED_DATE: null,
      STATUS: null,
      CLOSE_OF_ESCROW: null,
      NAME: calculateTotalColumn(data, "NAME", true),
      ADDRESS: null,
      CITY: null,
      STATE: null,
      PRICE: price ? dollars(price) : "$0",
      PERCENTAGE: null,
      SELLER_FEE_PERCENTAGE: null,
      GROSS_FEE: grossFee ? dollars(grossFee, true) : "$0.00",
      GROSS_CUMULATIVE: grossCumulative ? dollars(grossCumulative, true) : "$0.00",
      NET_FEE: netFee ? dollars(netFee, true) : "$0.00",
      ADDITIONAL_AGENTS: null,
      DOWNLOADS: downloads || 0,
      SELLER:null,
      FIRST_NAME:calculateTotalColumn(data, 'FIRST_NAME', true),
    };
  }
  checkIfHscAgent(name) {
    const hscTeamMember = hscTeamMembers.find(hscTeamMember => hscTeamMember.NAME === name);
    return hscTeamMember ? true : false;
  }
  static buildTable(status, table, data, grossType, id) {
    const tableData = { ...table };
    tableData.data = PipelineDetails.buildTableRows(status, data, grossType, id);
    const hasData = !!tableData.data.length;
    if (hasData) {
      tableData.total = PipelineDetails.buildTableTotal(tableData.data);
    }
    return tableData;
  }

  getValuesForDropdown(query, options, key, type = 'multiple') {
    if (!query || !options || !options.length) return [];

    let formattedQueryValues = query.ARCIMEDES_ROW_ID ? query.ARCIMEDES_ROW_ID : query.split(',');
    let response = [];

    options.forEach((el) => {
      if (!key) {
        if (formattedQueryValues.includes(el))
          response.push(el);
      } else {
        if (formattedQueryValues.includes(el[key]))
          response.push(el);
      }
    });

    if (!response) return [];
    if (type === "multiple") return response;
    return response[0];
  }

  handleChangeDropdown(event, reason, queryType, dropdownType = 'single', key = null) {
    const query = { ...this.state.query };

    if (!reason) {
      query[queryType] = null;
    } else {
      if (dropdownType === 'single') {
        if (!key)
          query[queryType] = reason;
        else
          query[queryType] = reason[key];
      } else {
        let result = '';
        reason.forEach(el => {
          if (!key)
            result += el + ',';
          else
            result += el[key] + ',';
        });
        query[queryType] = result;
      }
    }
    this.setState({ query });
  }

  handleChange(e) {
    const query = { ...this.state.query };
    query[e.currentTarget.name] = e.currentTarget.value;
    this.setState({ query });
  }

  handleTrasactionTypeChange(e, value) {
    const query = { ...this.state.query };
    query['AGENT_NAME'] = value.value;
    this.setState({ query });
  }

  onSubmit() {
    browserHistory.push({
      pathname: `${arc.path.base}agent-commission-breakdown/${this.state.query.DATE}/${this.state.query.AGENT_ID}/${this.state.query.AGENT_NAME ? this.state.query.AGENT_NAME : this.state.grossType}`,
      state: { paidProcuredonSubmit: true }
    })
  }
  checkIfHscAgent(name) {
      const hscTeamMember = hscTeamMembers.find(hscTeamMember => hscTeamMember.NAME === name);
      return hscTeamMember ? true : false;
  }
  sortBy(tableName, column, key) {
      const allowedTables = ['Courting', 'Properties', 'Follow Up'];
      if (!allowedTables.includes(tableName)) {
          return;
      }
      this.setState((prevState) => {
          
          const prevSort = (prevState.sortState || {})[tableName] || {};
          const isSameColumn = prevSort.sortKey === key;
          const newOrder = isSameColumn
              ? (prevSort.order === 'asc' ? 'dsc' : 'asc')
              : 'asc';

          return {
              sortState: {
                  ...prevState.sortState,
                  [tableName]: {
                      sortKey: key,
                      order: newOrder
                  }
              }
          };
      });
  }

  handleSort(colKey) {
  const { sortBy, sortDirection } = this.state;
  const newDirection = (sortBy === colKey && sortDirection === 'asc') ? 'desc' : 'asc';
  this.setState({ sortBy: colKey, sortDirection: newDirection });
  }

  getSortedData(data) {
  const { sortBy, sortDirection } = this.state;
  if (!sortBy) return data;

  const sortedData = [...data];
  sortedData.sort((a, b) => {
      const valA = a[sortBy];
      const valB = b[sortBy];

      if (valA === null || valA === undefined) return 1;
      if (valB === null || valB === undefined) return -1;

      if (typeof valA === 'number' && typeof valB === 'number') {
      return sortDirection === 'asc' ? valA - valB : valB - valA;
      }

      return sortDirection === 'asc'
      ? String(valA).localeCompare(String(valB))
      : String(valB).localeCompare(String(valA));
  });

  return sortedData;
  }
  renderTable(status, table, loading, isAgentPipeline, grossType,state,handleDate,handlegetValuesforDropdown,handleChangeDropdownValues,handleTrasactionTypes,applySubmit,transactionType, props) {
    const agentName = state.agentName;
    const cols = PipelineDetails.getColumns(status, isAgentPipeline, grossType);
    const data = table.data;
    const allowedTables = ['Courting', 'Properties', 'Follow Up'];
      let sortedData = [...(table.data || [])];

      if (allowedTables.includes(table.name)) {
      const sortConfig = (this.state.sortState && this.state.sortState[table.name]) || {};
      const sortKey = sortConfig.sortKey;
      const order = sortConfig.order;

      if (sortKey && order) {
          sortedData.sort((a, b) => {
          const valA = a[sortKey];
          const valB = b[sortKey];

          if (valA == null) return 1;
          if (valB == null) return -1;

          if (typeof valA === 'number' && typeof valB === 'number') {
              return order === 'asc' ? valA - valB : valB - valA;
          }

          return order === 'asc'
              ? String(valA).localeCompare(String(valB))
              : String(valB).localeCompare(String(valA));
          });
      }
    }
    const total = table.total;
    const message = loading ? "Loading data..." : "No data available";
    const isClosedOrProcurred = ['Closed - Paid','Closed - Procured','Closed'].includes(table.name)
        const displayTotal = Object.keys(total).length && total.NAME ? total.NAME : 0
        function handleChange(event){
            handleDate(event)
        }

        function handleTrasanctionChange(event,value){
            handleTrasactionTypes(event,value)
        }

        function getValuesForDropdown(query, options, key,type){
            return handlegetValuesforDropdown(query, options, key,type)
            
        }
        function handleChangeDropdown(event, reason, queryType, dropdownType, key = null){
            event.preventDefault()
            handleChangeDropdownValues(event, reason, queryType, dropdownType, key)
        }
        function handleOnSubmit(e){
            e.preventDefault();
            applySubmit()
        }

        // if(table.name === 'Hot List' && !(state.currentUserEmail === props.userData.email || props.isSuper)){   we removed condition has per client requiremnt 10408 ticket
        //     return
        // }    
    return (
      <React.Fragment>
        {
          isClosedOrProcurred ?
            <div className="agent-details-head">
              <div className="agent-details-left">
                <h4 className='agent-name-label'>Name: {agentName}</h4>
                <h4 style={{ margin: "0" }}>{table.name}</h4>
                <h4 style={{ margin: "0" }}>{`${displayTotal} Transactions`}</h4>
                <button className='agent-button' onClick={(e) => handleOnSubmit(e)}>Apply</button>
              </div>
              <div className="agent-details-right">
                <Autocomplete
                  className='white-old agent'
                  fullWidth
                  renderInput={(params) => { return <TextField {...params} label="Transaction Type" variant="outlined" /> }}
                  style={{ marginRight: '10px' }}
                  options={agentCommissionTransactionTypes}
                  onChange={(event, value) => { handleTrasanctionChange(event, value) }}
                  getOptionLabel={(option) => option.label}
                  value={agentCommissionTransactionTypes.find((option) => option.value === state.query.AGENT_NAME)}
                  defaultValue={agentCommissionTransactionTypes.find((option) => option.value === transactionType)}
                />
                <Input
                  name='DATE'
                  value={state.query.DATE}
                  label='YEAR'
                  onChange={handleChange}
                />
                <SelectTeam theme='white-old agent'
                  name='AGENT_ID'
                  value={state && state.query && Object.keys(state.query) && state.query.AGENT_ID}
                  onChange={handleChangeDropdown}
                  label='AGENT'
                  getValue={getValuesForDropdown}
                  onlyAgents
                />
              </div>
            </div>
            :
            <h4 id={table.name.split("-")[0].trim() + "scroll"}>{table.name}</h4>
        }
        {
          allowedTables.includes(table.name) && table.data.length ?
            <table className='table'>
                <thead>
                    <tr>
                        {cols.map((col, index) => (
                        <th key={col.key} className={`th head border_top agent-head ${index === 0 ? 'border_left' : ''}`}>
                            <div className="SortTable_th_name">
                            <button className="btn-text" onClick={() => this.sortBy(table.name,col, col.key)}>
                                <div className={`SortTable_th_name ${this.state.sortKey === col.key && (this.state.order === "asc" || this.state.order === "dsc") ? "active" : ""}`}>
                                <span className={`SortTable_th_name_icon top ${this.state.sortKey === col.key && this.state.order === "asc" ? "active" : ""}`}>
                                    <Icon svg={svgSortAsc} />
                                </span>
                                {col.label}
                                <span className={`SortTable_th_name_icon bottom ${this.state.sortKey === col.key && this.state.order === "dsc" ? "active" : ""}`}>
                                    <Icon svg={svgSortDesc} />
                                </span>
                                </div>
                            </button>
                            </div>
                        </th>
                        ))}
                    </tr>
                    </thead>
                <tbody>
                    {                                   
                        sortedData.map((row, index) => (
                        <tr key={index}>
                            {cols.map((col, colIndex) => {
                            if (col.key === 'ID') return null;

                            const value = col.isPrice
                                ? dollars(row[col.key], col.withCents)
                                : row[col.key];

                            return (
                                <td
                                className={`td ${colIndex === 0 ? 'border_left' : ''}`}
                                style={{ textAlign: col.style ? 'center' : '' }}
                                key={`${colIndex}_${row.ID}`}
                                >
                                {col.key === 'NAME' ? (
                                    <Link to={{ pathname: `${arc.path.base}property/${row.ID}` }}>
                                    {value}
                                    </Link>
                                ) : col.key === 'DOWNLOADS' ? (
                                    <Link to={{ pathname: `${arc.path.base}property-statistics/${row.ID}` }}>
                                    {value}
                                    </Link>
                                ) : col.key === 'PROCURED' ? (
                                    <div>{value ? 'Yes' : 'No'}</div>
                                ) : (
                                    <div>{value}</div>
                                )}
                                </td>
                            );
                            })}
                        </tr>
                        ))

                    }
                </tbody>                           

                <tfoot>
                    <tr>
                        {
                        sortedData.length ? cols.map((col, index) => {
                            if (index === 0) {
                            return <th className='th border_left' key='TOTAL'>Total</th>
                            }
                            return <th className='th' key={col.key}>{total[col.key]}</th>
                        }) : null
                        }
                    </tr>
                </tfoot>

            </table>: table.data.length ? (
            <table className="table">
              <thead style={{top:isClosedOrProcurred ? "264px" :"0",position:isClosedOrProcurred ?"sticky":"static"}}>
                <tr>
                  {
                    cols.map((col, index) => {
                      return (
                        <th className={`th head border_top ${index === 0 ? "border_left" : ""}`}
                          key={col.key} >
                          {col.label}
                        </th>
                      );
                    })
                  }
                </tr>
              </thead>
              <tbody>
                {Object.keys(data).map((rowKey, index) => {
                  return (
                    <tr key={index}>
                      {
                      cols.map((col, index) => {
                        if (col.key === "ID") 
                          return;
                        const value = col.isPrice ? dollars(data[rowKey][col.key], col.withCents) : data[rowKey][col.key];
                        return (
                          <td
                            className={`td ${index === 0 ? "border_left" : ""}`}
                            style={{ textAlign: col.style ? "center" : "" }}
                            key={`${index}_${data[rowKey].ID}`}
                          >
                            {
                            col.key === "NAME" ? (
                              <Link to={{
                                  pathname: `${arc.path.base}property/${data[rowKey].ID}`, 
                                  state: { fromListUrl: window.location.pathname + window.location.search }
                                  }} style={{ cursor: "pointer" }}>
                                {value}
                              </Link>
                            ) : col.key === "DOWNLOADS" ? (
                              <Link to={{
                                  pathname: `${arc.path.base}property-statistics/${data[rowKey].ID}`,
                                  state: { fromListUrl: window.location.pathname + window.location.search }
                                }} style={{ cursor: "pointer" }}
                                   >
                                {value}
                              </Link>
                            ) : col.key === "PROCURED" ? (
                              <div>{value ? "Yes" : "No"}</div>
                            ) : (
                              <div>{value}</div>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                {
                  <tr>
                    {
                    data.length ? cols.map((col, index) => {
                        if (index === 0) {
                          return ( <th className="th border_left" key="TOTAL"> Total </th> );
                        }
                        return ( <th className="th" key={col.key}> {total[col.key]} </th> );
                      })
                      : null}
                  </tr>
                }
              </tfoot>
            </table>
          ) : (
            <div className="no-data-found">{message}</div>
          )}
      </React.Fragment>
    );
  }

  static renderChart(status, table, loading, isAgentPipeline, grossType, componentName) {
    const total = table.total ? table.total : 0;
    let message = "";
    const radius = 100;
    const circle_style = "height=30";
    let startColor = "red";
    let endColor = "red";
    let circleStyle = "red";
    let circlePer = 0;
    let displayTotal = total.NAME;
    let name = table.name;

    if (['Closed - Paid', 'Closed - Procured', 'Closed'].includes(table.name)) return;

    if (table.name === "Proposals") {
      message = `(Goal = ${table.goalValue ? table.goalValue : 0}+)`;
      name = "Proposals";
      displayTotal = (table.name === "Proposals" && componentName === 'bucketDetails') ? table.data.filter((e) => e.STATUS === "Proposal" && e.SOURCE === "STRIVE").length : displayTotal;
      switch (displayTotal) {
        case 1: {
          circlePer = 25;
        }
          break;
        case 2: circlePer = 50; break;
        case 3: circlePer = 75; break;
        default:
          if (displayTotal) {
            startColor = "#90C54B";
            endColor = "#90C54B";
            circleStyle = "#90C54B";
            circlePer = 100;
          }
      };
    } else if (
      table.name === "Listings - YTD" || table.name === "Active Listings") {
      if (table.name === "Listings - YTD") {
        name = "Listings";
      }
      message = `(Goal = ${table.goalValue ? table.goalValue : 0}+)`;
      displayTotal = table.data.filter((e) => e.STATUS === "Active").length;
      if (displayTotal >= table.goalValue) {
        circlePer = 100;
        startColor = "#90C54B";
        endColor = "#90C54B";
        circleStyle = "#90C54B";
      } else {
        circlePer = (displayTotal / table.goalValue) * 100;
        startColor = "red";
        endColor = "red";
        circleStyle = "red";
      }
    }
    else if (["Closed - YTD", "Closed - YTD", "Closed-procured", "Closed - procured"].includes(table.name)) {
      message = `(Goal = ${table.goalValue ? table.goalValue : 0}+)`;
      displayTotal = table.name === "Closed - YTD" ? table.data.filter((e) => e.TRANSACTION_TYPE == "Investment Sales").length : displayTotal;
      const currentMonth = new Date().getMonth() + 1;
      if (displayTotal >= table.goalValue) {
        circlePer = 100;
        startColor = "#90C54B";
        endColor = "#90C54B";
        circleStyle = "#90C54B";
      }
      else if ((currentMonth * table.goalValue / 12) < displayTotal) {
        circlePer = (displayTotal / table.goalValue) * 100;
        startColor = "#90C54B";
        endColor = "#90C54B";
        circleStyle = "#90C54B";
      } else if ((currentMonth * table.goalValue / 12) > displayTotal) {
        circlePer = (displayTotal / table.goalValue) * 100;
        startColor = "red";
        endColor = "red";
        circleStyle = "red";
      }
    }
    else if (table.name === "Under Contract" || table.name === "Neg/Under Contract") {
      message = `(Goal = ${table.goalValue ? table.goalValue : 0}+)`;
      displayTotal = table.data.filter((e) => e.STATUS === "Under Contract" || e.STATUS === "In Negotiation").length;
      if (displayTotal >= table.goalValue) {
        circlePer = 100;
        startColor = "#90C54B";
        endColor = "#90C54B";
        circleStyle = "#90C54B";
      }
      else {
        circlePer = (displayTotal / table.goalValue) * 100;
        startColor = "red";
        endColor = "red";
        circleStyle = "red";
      }
    }else if (table.name === 'Lenders') {
        message = `(Goal = ${'10'}+)`;
        displayTotal = table.data.length;
        if (displayTotal >= 10) {
            circlePer = 100;
            startColor = '#538ef2';
            endColor = '#538ef2';
            circleStyle = '#538ef2';
        }
        else {
            circlePer = displayTotal / 10 * 100;
            startColor = 'red';
            endColor = 'red';
            circleStyle = 'red';
        }
    }else if (table.name === 'Agents') {
        message = `(Goal = ${'10'}+)`;
        displayTotal = table.data.length;
        if (displayTotal >= 10) {
            circlePer = 100;
            startColor = '#538ef2';
            endColor = '#538ef2';
            circleStyle = '#538ef2';
        }
        else {
            circlePer = displayTotal / 10 * 100;
            startColor = 'red';
            endColor = 'red';
            circleStyle = 'red';
        }
    }else if (table.name === 'Properties') {
        message = `(Goal = ${'10'}+)`;
        displayTotal = table.data.length;
        if (displayTotal >= 10) {
            circlePer = 100;
            startColor = '#538ef2';
            endColor = '#538ef2';
            circleStyle = '#538ef2';
        }
        else {
            circlePer = displayTotal / 10 * 100;
            startColor = 'red';
            endColor = 'red';
            circleStyle = 'red';
        }
    }else if (table.name === 'Investors'|| table.name === 'Follow Up' || table.name === 'Courting') {
        message = `(Goal = ${'10'}+)`;
        displayTotal = table.data.length;
        if (displayTotal >= 10) {
            circlePer = 100;
            startColor = '#538ef2';
            endColor = '#538ef2';
            circleStyle = '#538ef2';
        }
        else {
            circlePer = displayTotal / 10 * 100;
            startColor = 'red';
            endColor = 'red';
            circleStyle = 'red';
        }
    }

    return (
      <div className="chartOption" style={{ textAlign: "center" }}>
        <BucketIcon circlePer={circlePer} total={displayTotal} name={name} startColor={startColor} message={message} />
      </div>
    );
  }

  static getMonthsFromDate(inputDate) {
    // Parse the input date
    const input = new Date(inputDate);
    const today = new Date();
    
    // Extract year and month from both dates
    const inputYear = input.getFullYear();
    const inputMonth = input.getMonth();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    
    // Calculate the difference in months
    const totalMonths = (currentYear - inputYear) * 12 + (currentMonth - inputMonth);
    return totalMonths;
}

  static getCurrentYearData(data, key, tableName,componentName) {
    if ( [ "Proposal", "Listing", "Listings - YTD", "Closed - YTD", "Closed", ].includes(key)) {
      const year = new Date().getFullYear();
      let _filteredData = (tableName == "Listings - YTD" || (tableName == "Proposals" && componentName === 'bucketDetails')) ? data.data.filter((e) => {
              if (((moment(e.LISTED_DATE).year() === year && tableName == "Listings - YTD") || (PipelineDetails.getMonthsFromDate(e.PROPOSAL_DATE) <= 12 && tableName == 'Proposals')) &&  (e.SOURCE === "STRIVE") || (e.LIST_PRICE == "null")) {
                return e;
              }
            }) : data.data;

      data.total["NAME"] = _filteredData.length;
      return { ...data, data: _filteredData };
    }
    return data;
  }

  render() {
    const { tables, agentName, loading, grossType, componentName,loader } = this.state;
    const { withoutAgentName, isAgentPipeline, location: { pathname } } = this.props;
    const transactionType = pathname.split("/")[pathname.split("/").length - 1];
    const isClosedOrProcurred = pathname.match(/(paid|procured)/);
    return (
      <ApolloConsumer>
        {(client) => {
          if (!this.client) {
            this.client = client;
          }
          return (
            <div className="agent-details-container">
              {(withoutAgentName || isClosedOrProcurred) ? null : (
                <div>
                    {this.checkIfHscAgent(agentName) ? (
                        <h3>AthCap - Hot List</h3> 
                    ) : null}
                    <div className="agent-details">
                    <h4 className="agent-name-label">Name:</h4>
                    <h4 className="agent-name">{agentName}</h4>
                    </div>
                </div>
              )}
              <div className="chartgrid" style={{ display: "flex" }}>
                {
                  Object.keys(tables).map((key) => {
                    return (tables[key].name !== "Closed - Historical" && tables[key].name !== 'Hot List' && (
                      <div key={key} style={{ width: "100%" }}>
                        {PipelineDetails.renderChart(key, tables[key], loading, isAgentPipeline, grossType, this.state.componentName)}
                      </div>
                    )
                    );
                  })}
              </div>
              {
                Object.keys(tables).map(key => {
                  return <React.Fragment key={key}>{this.renderTable(key, PipelineDetails.getCurrentYearData(tables[key], key, tables[key].name, this.state.componentName), loading, isAgentPipeline, grossType, this.state, this.handleChange, this.getValuesForDropdown, this.handleChangeDropdown, this.handleTrasactionTypeChange, this.onSubmit, transactionType, this.props)}</React.Fragment>
                })
              }
              {/* {Object.keys(tables).map((key) => {
                return (
                  <div key={key}>
                    {PipelineDetails.renderTable(
                      key,
                      PipelineDetails.getCurrentYearData(
                        tables[key],
                        key,
                        tables[key].name,
                        componentName
                      ),
                      loading,
                      isAgentPipeline,
                      grossType
                    )}
                  </div>
                );
              })} */}
              {loader && <ReusableSpinner/>}
            </div>
          );
        }}
      </ApolloConsumer>
    );
  }
}
